{
  "title": "أهلًا بك في bPanel",
  "description": "أضف سيرفرك الأول وثبّت bPanel خلال دقائق."
}
